<template>
  <div>
    <div class="operaBox padding-lr-sm">
      <SecondTitle :secTitle="secTitle"></SecondTitle>
      <!--		<PassagewayChart></PassagewayChart>-->
      <div class="operation flex align-center justify-around padding-tb-xs">
        <!--		  <div class="text-xss text-white">建设中通道</div>-->
        <div class="text-xss text-white">充电</div>
        <div
          class="text-xss text-green flex flex-direction align-center number"
          style="position: relative"
        >
          <!-- <span class="yunying-text">{{ chargeTotalCityNum }}</span> -->
          <span class="yunying-text">0</span>
          <img
            class="operation-icon"
            src="../../assets/images/index/haveIcon.png"
          />
          上线城市
        </div>
        <div
          class="text-xss text-green flex flex-direction align-center number"
          style="position: relative"
        >
          <!-- <span class="yunying-text">{{ total_station_num }}</span> -->
          <span class="yunying-text">0</span>
          <img
            class="operation-icon"
            src="../../assets/images/index/haveIcon.png"
          />
          充电站数
        </div>
      </div>
      <!-- <div class="operation flex align-center justify-around padding-tb-xs">
		  <div class="text-xss text-white">已签约通道</div>
		  <div class="text-xss text-green flex flex-direction align-center number">
			  <div class="number_icon">自有{{signedPassNum}}</div>
			  <img class="operation-icon" src="../../assets/images/index/haveIcon.png" />
		  </div>
		  <div class="text-xss text-green flex flex-direction align-center number">
			  <div class="number_icon">全国{{signedPassNum}}</div>
			  <img class="operation-icon" src="../../assets/images/index/haveIcon.png" />
		  </div>
		</div> -->
      <div class="operation flex align-center justify-around padding-tb-xs">
        <!--		  <div class="text-xss text-white">充电港</div>-->
        <div class="text-xss text-white">换电</div>
        <div
          class="text-xss text-green flex flex-direction align-center number"
          style="position: relative"
        >
          <span class="yunying-text">{{ swapTotalCityNum }}</span>
          <img
            class="operation-icon"
            src="../../assets/images/index/haveIcon.png"
          />
          上线城市
        </div>
        <div
          class="text-xss text-green flex flex-direction align-center number"
          style="position: relative"
        >
          <span class="yunying-text">{{ changeStation }}</span>
          <img
            class="operation-icon"
            src="../../assets/images/index/haveIcon.png"
          />
          换电站数
        </div>
      </div>
      <!--		<div class="operation flex align-center justify-around padding-tb-xs">-->
      <!--		  <div class="text-xss text-white">移动能源车</div>-->
      <!--		  <div class="text-xss text-green flex flex-direction align-center number">-->
      <!--			  <div class="number_icon">自有{{mobileVehicleNum}}</div>-->
      <!--			  <img class="operation-icon" src="../../assets/images/index/haveIcon.png" />-->
      <!--		  </div>-->
      <!--		  <div class="text-xss text-green flex flex-direction align-center number">-->
      <!--			  <div class="number_icon">全国{{allmobileVehicleNum}}</div>-->
      <!--			  <img class="operation-icon" src="../../assets/images/index/haveIcon.png" />-->
      <!--		  </div>-->
      <!--		</div>-->
    </div>
  </div>
</template>

<script>
import SecondTitle from "../secondTitle.vue";
import PassagewayChart from "../echart/siteCharts/passagewayChart.vue";
import { indexRight } from "@/api/indexRight";
import { dataInterface } from "@/api/dataInterfaceApi";
import { mapState, mapMutations } from "vuex";

export default {
  data() {
    return {
      passagewayData: {},
      secTitle: {
        title: "运营布局",
      },
      passNum: [],
      setPassNum: "",
      allsetPassNum: "",
      chargingNum: "", //充电港
      allchargingNum: "",
      mobileVehicleNum: "", //移动能源车
      allmobileVehicleNum: "",
      chargeTotalCityNum: "", //充电上线城市
      swapTotalCityNum: "", //换电上线城市
	  changeStation: ""
    };
  },
  components: {
    SecondTitle,
    PassagewayChart,
  },
  computed: {
    ...mapState(["total_station_num", "stationAccessNum"]),
  },
  watch: {},
  mounted() {},
  methods: {
    getData(data) {
      this.getPassNum(data);
      this.chongdiangangyidongnengyuanche(data);
    },
    //数据接口-建设中通道、运营中通道
    getPassNum(data = {}) {
      this.getMonthlyIncreaseChannel(data);

      // let _this = this;
      // 			let params = {};
      // 			this.setPassNum='0';
      // 			if(data){
      // 				//省市区
      // 				this.yunyingbuju({
      // 					"enCode":"TiDB-shengshiqu-yunyingbuju",
      //     			"@province":data.province||data.city||data.district
      // 				},true);
      // 				this.yunyingbujuAll({
      // 					"enCode":"TiDB-quanguo-yunyingbuju"//全国
      // 				},false)
      // 			}else {
      // 				this.yunyingbuju({
      // 					"enCode":"TiDB-quanguo-yunyingbuju"//全国
      // 				},false)
      // 			}
    },
    // 获取月增通道数四个数据
    getMonthlyIncreaseChannel(data) {
      this.getChargeTotalCityNum(data);
      this.getSwapTotalCityNum(data);
      // this.userStickiness= '';
      // this.vehicleStickiness= '';
      // let ADCODE= data?data.province||data.city||data.district:'000000';
      // dataInterface
      // 	.dataFaceApi({
      // 		"enCode":"TiDB-xiazuan-yunying",
      // 		"@station_type":"充电桩",
      // 		"@ADCODE":ADCODE
      // 	})
      // 	.then((res) => {
      // 		if(!res) return;
      // 		res=res[0];
      // 		this.activeUsers= res.vehicleAvtiveNum;
      // 		this.activeVehicles= res.userActiveNum;
      // 		this.userStickiness= res.vehicleViscidity;
      // 		this.vehicleStickiness= res.userViscidity;
      // 	})
      // 	.catch((err) => {
      // 		console.log(err);
      // 	});
    },
    // 获取充电上线城市
    getChargeTotalCityNum(data) {
      this.chargeTotalCityNum = "";
      const { query } = this.$route
      if(query.token) localStorage.setItem('uid',query.token )
      let params = {
        enCode: "hdz-yyqs",
        "@province": data.province || data.city || data.district || "000000",
        '@uid': localStorage.getItem('uid') || '000000'
      };
      dataInterface
        .dataFaceApiXZ(params)
        .then((res) => {
          if (!res) return;
          res = res[0];
          this.swapTotalCityNum = res.sxcs;
		  this.changeStation =  res.hdzs
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 获取换电上线城市
    getSwapTotalCityNum(data) {
      this.swapTotalCityNum = "";
      let ADCODE = data
        ? data.province || data.city || data.district
        : "000000";
      dataInterface
        .dataFaceApi({
          enCode: "TiDB-xiazuan-yunying",
          "@station_type": "换电站",
          "@ADCODE": ADCODE,
        })
        .then((res) => {
          if (!res) return;
          res = res[0];
          this.swapTotalCityNum = res.total_city_num;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    yunyingbuju(params, flag) {
      dataInterface
        .dataFaceApi(params)
        .then((res) => {
          if (!res) return;
          this.passNum = res;
          this.passNum.map((item) => {
            if (item.operate_status == 0) {
              //建设中
              if (flag) {
                this.setPassNum = item.PpssNum;
                return;
              }
              this.setPassNum = item.PpssNum;
              this.allsetPassNum = item.PpssNum;
            }
          });
        })
        .catch((err) => {
          console.log(err);
        });
    },
    yunyingbujuAll(params) {
      dataInterface
        .dataFaceApi(params)
        .then((res) => {
          if (!res) return;
          this.passNum = res;
          this.passNum.map((item) => {
            if (item.operate_status == 0) {
              //建设中
              this.allsetPassNum = item.PpssNum;
            }
          });
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 充电港、移动能源车
    chongdiangangyidongnengyuanche(data = {}) {
      if (data) {
        //省市区
        this.selectStationOperCurrent(
          {
            enCode: "TiDB-shengshiqu-chongdiangangyidongnengyuanche",
            "@province": data.province || data.city || data.district,
          },
          true
        );
        this.selectStationOperCurrentAll(
          {
            enCode: "TiDB-quanguo-chongdiangangyidongnengyuanche", //全国
          },
          false
        );
      } else {
        this.selectStationOperCurrent(
          {
            enCode: "TiDB-quanguo-chongdiangangyidongnengyuanche", //全国
          },
          false
        );
      }
    },
    selectStationOperCurrent(params, flag) {
      let _this = this;
      dataInterface
        .dataFaceApi(params)
        .then((res) => {
          if (!res) return;
          res = res[0];
          if (flag) {
            this.chargingNum = res.chargingNum;
            this.mobileVehicleNum = res.mobileVehicleNum;
            return;
          }
          this.chargingNum = res.chargingNum;
          this.mobileVehicleNum = res.mobileVehicleNum;

          this.allchargingNum = res.chargingNum;
          this.allmobileVehicleNum = res.mobileVehicleNum;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    selectStationOperCurrentAll(params) {
      let _this = this;
      dataInterface
        .dataFaceApi(params)
        .then((res) => {
          if (!res) return;
          res = res[0];
          this.allchargingNum = res.chargingNum;
          this.allmobileVehicleNum = res.mobileVehicleNum;
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};
</script>
<style lang="scss" scoped>
.operaBox {
  width: 438px;
  //min-height:473px;
  min-height: 343px;
  border-radius: 10px;
  background: linear-gradient(
    180deg,
    rgba(47, 164, 159, 0.11) 0%,
    rgba(1, 177, 169, 0.06) 79%,
    rgba(53, 149, 147, 0.11) 100%
  );
}
.operation-icon {
  width: 82px;
  height: 72px;
}
.number {
  position: relative;
}
.number_icon {
  position: absolute;
  bottom: 40px;
}
.text-white {
  min-width: 90px;
  text-align: center;
}
.operaBox {
  background: rgba(19, 29, 35, 0.6);
}

.yunying-text {
  color: #ffffff;
  position: absolute;
  top: 4px;
}
</style>